import styled from "styled-components";
import { Link } from "react-router-dom";

export const StickyNav = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 32px 80px 0;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  background: transparent;
  
  &.scrolled {
    padding: 24px 80px;
    margin: 10px;
    background: #101015;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    
    &.contact-page {
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      width: calc(100% - 20px);
      z-index: 1001;
      margin: 0 auto;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
    }
  }

  @media (max-width: 768px) {
    padding: 24px 24px 0;
    /* Remove left/right to allow full width centering */
    left: 0;
    right: 0;
    margin: 0;
    
    &.scrolled {
      padding: 16px 24px;
      margin: 10px;
      left: 10px;
      right: 10px;
      width: auto;
      transform: none;
      
      &.contact-page {
        padding: 16px 20px;
        margin: 0px;
        width: auto;
        top: 10px;
        left: 10px;
        right: 10px;
        transform: none;
      }
    }
  }
`;

export const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const NavContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;

  @media (max-width: 768px) {
    gap: 0;
  }
`;

export const Logo = styled.div`
  font-weight: 700;
  font-size: 20px;
  z-index: 1002;
  
  a {
    text-decoration: none;
    color: #fff;
    transition: color 0.3s ease;
    display: flex;
    align-items: center;
    gap: 12px;
    
    &:hover {
      color: #ccc;
    }
  }
`;

export const LogoImage = styled.img`
  height: 25px;
  width: auto;
  transition: all 0.3s ease;
  
  @media (max-width: 768px) {
    height: 25px;
  }
`;

export const LogoText = styled.span`
  font-weight: 700;
  font-size: 20px;
  color: #fff;
  
  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

export const NavLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;

  a, .dropdown-toggle {
    text-decoration: none;
    font-weight: 500;
    transition: all 0.3s ease;
    color: #fff;
    background: none;
    border: none;
    cursor: pointer;
    font-family: inherit;
    font-size: inherit;
    padding: 0;
    
    &:hover {
      color: #ccc;
    }
  }

  .dropdown-toggle {
    display: flex;
    align-items: center;
    
    &.active {
      color: #ccc;
    }
  }

  @media (max-width: 768px) {
    position: fixed;
    top: 0;
    right: 0;
    height: 100vh;
    width: 70%;
    max-width: 300px;
    background: #101015;
    flex-direction: column;
    padding: 100px 32px 32px; /* Increased top padding from 80px to 100px */
    gap: 24px;
    transform: translateX(100%);
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: -4px 0 20px rgba(0, 0, 0, 0.3);
    z-index: 9999;
    align-items: flex-start;
    overflow-y: auto; /* Allow scrolling if content is too long */

    &.open {
      transform: translateX(0);
    }

    a, .dropdown-toggle {
      font-size: 18px;
      color: #fff;
      width: 100%;
      text-align: left;
      justify-content: space-between;
      padding: 0;
    }

    .mobile-only {
      display: block;
      margin-top: 16px;
    }
  }

  .mobile-only {
    display: none;
  }
`;

export const Dropdown = styled.div`
  position: relative;
  display: inline-block;
`;

export const DropdownArrow = styled.span`
  display: flex;
  align-items: center;
  margin-left: 6px;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  
  &.open {
    transform: rotate(180deg);
  }
  
  svg {
    stroke-width: 2.5;
  }
`;

export const DropdownContent = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 8px;
  min-width: 220px;
  background: #101015;
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1000;
  border: 1px solid rgba(255, 255, 255, 0.15);
  overflow: hidden;
  backdrop-filter: blur(10px);

  &.open {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    position: static;
    width: 100%;
    margin-top: 8px;
    box-shadow: none;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    max-height: 0;
    overflow: hidden;
    opacity: 0;
    transform: none;
    transition: all 0.3s ease;
    backdrop-filter: none;

    &.open {
      max-height: 400px;
      opacity: 1;
      visibility: visible;
      margin-bottom: 16px;
      padding: 8px 0;
    }
  }
`;

export const DropdownItem = styled.button`
  display: block;
  width: 100%;
  padding: 12px 20px;
  text-align: left;
  background: none;
  border: none;
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
  white-space: nowrap;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #ccc;
  }

  &:first-child {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  &:last-child {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  @media (max-width: 768px) {
    font-size: 16px;
    padding: 12px 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);

    &:last-child {
      border-bottom: none;
    }
  }
`;

export const BookSpaceButton = styled.button`
  background: white;
  color: black;
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 10px 24px;
  border-radius: 999px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;

  &:hover {
    background: #f5f5f5;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: translateY(0);
  }

  &.desktop-only {
    @media (max-width: 768px) {
      display: none;
    }
  }

  @media (max-width: 768px) {
    &.desktop-only {
      display: none;
    }

    &.mobile-only {
      display: block;
      width: 100%;
      padding: 12px 20px;
      font-size: 16px;
      margin-top: 16px;
      background: white;
      color: black;
      border-radius: 999px;
    }
  }
`;

export const HamburgerButton = styled.button`
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  z-index: 1002;
  color: #fff;
  
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin-left: auto;
  }
`;

export const HamburgerLine = styled.span`
  width: 24px;
  height: 2px;
  background: #fff;
  transition: all 0.3s ease;
  
  ${HamburgerButton}.open &:nth-child(1) {
    transform: rotate(45deg) translate(6px, 6px);
  }
  
  ${HamburgerButton}.open &:nth-child(2) {
    opacity: 0;
  }
  
  ${HamburgerButton}.open &:nth-child(3) {
    transform: rotate(-45deg) translate(6px, -6px);
  }
`;

export const HamburgerIcon = styled.div`
  display: none;
  
  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    z-index: 1002;
    
    svg {
      width: 100%;
      height: 100%;
      transition: all 0.3s ease;
    }
  }
`;

export const Overlay = styled.div`
  display: none;
  
  @media (max-width: 768px) {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s ease;
    z-index: 999;

    &.open {
      opacity: 1;
      pointer-events: all;
    }
  }
`;